import {
  keyArgsForPaginationWithFilters,
  mergeForPaginationWithFilters,
} from "./modules/utils";

const TranscriptV3BulkUploadTransactionTypePolicy = {
  TranscriptV3BulkUploadTransaction: {
    fields: {
      summaryRows: {
        keyArgs: args => {
          if (args) {
            return keyArgsForPaginationWithFilters(args);
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPaginationWithFilters({
              existing,
              incoming,
              readField,
              fieldVariables: args,
            });
          }
          return incoming;
        },
      },
    },
  },
};

export default TranscriptV3BulkUploadTransactionTypePolicy;
